export const header = {
	help: {
		sv: "Hjälp",
	},
	helpLink: {
		sv: "https://www.svea.com/sv-se/foretag/f%C3%B6retagsbanken/hj%C3%A4lp",
	},
	abortApplication: {
		sv: "Avbryt ansökan",
	},
	abortApplicationModal: {
		title: { sv: "Vill du avbryta din ansökan?" },
		description: {
			sv: `Om du avbryter ansökan kommer all information du angett av förloras. Vill du spara
      informationen du angett hittils men fortsätta med ansökan senare kan du istället välja
      att logga ut. Då sparas din ansökan och du kan fortsätta senare.`,
		},
	},
	logout: {
		sv: "Logga ut",
	},
	linkText: {
		sv: "Svea.com",
	},
	linkUrl: {
		sv: "https://www.svea.com/se/sv/",
	},
	noCompanyName: {
		sv: "Nytt Företag",
	},
	noOrgNr: {
		sv: "Inget organisationsnummer",
	},
	backToDashboard: {
		sv: "Tillbaka till välj företag",
	},
};
